import React from "react";
import { ArrowRight, Check, Package } from "lucide-react";
import { HERO_BENEFITS, PACKAGES } from "../data/mock";

export default function HeroPackagesPreview() {
  return (
    <section
      id="pacchetti-preview"
      className="relative py-16 md:py-20 overflow-hidden"
      data-testid="hero-packages-preview"
    >
      {/* Mini Packages Preview */}
      <div className="relative max-w-7xl mx-auto px-5 md:px-8">
        <div className="reveal flex items-end justify-between gap-4 mb-5">
          <div>
            <div className="text-xs font-bold tracking-[0.22em] uppercase text-[#f59e0b]">
              I nostri pacchetti
            </div>
            <h3 className="mt-2 text-xl md:text-2xl font-extrabold text-[#0a1f55]">
              Scegli e inizia subito
            </h3>
          </div>
          <a
            href="#pacchetti"
            className="hidden sm:inline-flex items-center gap-1 text-[13px] font-bold text-[#102a6b] hover:text-[#0a1f55]"
            data-testid="mini-vedi-tutti"
          >
            Vedi tutti i pacchetti
            <ArrowRight className="h-4 w-4" />
          </a>
        </div>
        <div className="grid md:grid-cols-3 gap-4">
          {PACKAGES.map((p, i) => (
            <a
              key={p.id}
              href="#pacchetti"
              data-testid={`mini-pkg-${p.id}`}
              className="reveal group relative rounded-2xl border bg-white p-5 lift overflow-hidden border-slate-200 hover:border-[#102a6b]/50"
              style={{ transitionDelay: `${i * 60}ms` }}
            >
              {p.badge && (
                <div
                  className={`absolute top-4 right-4 px-2 py-0.5 rounded-full text-[10px] font-bold uppercase tracking-wider ${
                    p.accent
                      ? "bg-[#f59e0b] text-[#0a1f55]"
                      : "bg-[#102a6b]/10 text-[#102a6b]"
                  }`}
                >
                  {p.badge}
                </div>
              )}
              <div className="flex items-center gap-2">
                <Package className="h-4 w-4 text-[#f59e0b]" />
                <div className="text-[11px] uppercase tracking-wider text-slate-500 font-semibold">
                  Pacchetto {i + 1}
                </div>
              </div>
              <h4 className="mt-2 text-base font-extrabold text-[#0a1f55] leading-tight">
                {p.name}
              </h4>
              <div className="mt-3 flex items-baseline gap-1">
                <span className="text-3xl font-extrabold text-[#102a6b]">
                  € {p.total.toString().replace(".", ",")}
                </span>
                <span className="text-xs text-slate-500">/ una tantum</span>
              </div>
              <ul className="mt-4 space-y-1.5">
                {p.features.slice(0, 3).map((f) => (
                  <li
                    key={f}
                    className="flex items-start gap-2 text-[12.5px] text-slate-600"
                  >
                    <Check className="h-3.5 w-3.5 mt-0.5 text-[#f59e0b] shrink-0" />
                    <span className="line-clamp-1">{f}</span>
                  </li>
                ))}
              </ul>
              <div className="mt-4 inline-flex items-center gap-1 text-[12.5px] font-bold text-[#102a6b] group-hover:gap-2 transition-all">
                Scopri di più
                <ArrowRight className="h-3.5 w-3.5" />
              </div>
            </a>
          ))}
        </div>
      </div>

      {/* Benefits cards */}
      <div className="relative max-w-7xl mx-auto px-5 md:px-8 mt-16 md:mt-24">
        <div className="grid md:grid-cols-3 gap-5">
          {HERO_BENEFITS.map((b, i) => (
            <div
              key={b.title}
              className="reveal gradient-border rounded-2xl p-6 lift"
              style={{ transitionDelay: `${i * 80}ms` }}
              data-testid={`hero-benefit-${i}`}
            >
              <div className="flex items-center justify-between">
                <div className="h-9 w-9 rounded-lg bg-[#102a6b] text-white flex items-center justify-center font-bold text-sm">
                  0{i + 1}
                </div>
                <div className="h-2 w-2 rounded-full bg-[#f59e0b]"></div>
              </div>
              <h3 className="mt-4 text-[17px] font-bold text-[#0a1f55] leading-snug">
                {b.title}
              </h3>
              <p className="mt-2 text-[14.5px] text-slate-600 leading-relaxed">
                {b.text}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
